import { createSlice } from "@reduxjs/toolkit";

const initialnewAdscompanylistSlice = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  contestData: [],
  contestUsers: [],
  retentionreportlist: [],
  gameList: [],
  uploadimage: [],
  ruless: {},
  gameTypeList: [],
  company: [],
  currency: [],
  upload: {},
  imageField: undefined,
  screenShots: [],
  screenshot: [],
  totalJoinedPlayers: 0,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const NewAdscompanylistSlice = createSlice({
  name: "newAdscompanylistSlice",
  initialState: initialnewAdscompanylistSlice,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    itemCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.item);
      state.entities = [];
    },
    company: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.company = entities;
      // state.totalCount = totalCount;
    },
    currency: (state, action) => {
      const { totalCount, entities } = action.payload;
      // console.log(entities)
      state.listLoading = false;
      state.error = null;
      state.currency = entities;
      // state.totalCount = totalCount;
    },
    // itemUpdated: (state, action) => {
    //   state.error = null;
    //   state.actionsLoading = false;
    //   state.entities = [];
    // },
    uploadImageSuccess: (state, action) => {
      const { uploadimage, imageField } = action.payload;
      state.error = null;
      state.errorFound = false;
      state.uploadimage = uploadimage;
      state.imageField = imageField;
    },
    uploadImageFailure: (state, action) => {
      state.error = action.payload;
      state.errorFound = true;
    },

    // singleItemFetched: (state, action) => {
    //   state.actionsLoading = false;
    //   state.ruless = action.payload.ruless;
    //   state.error = null;
    // },

    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryList = countryList;
    },

    CountryDropdownList: (state, action) => {
      const { countryDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },
    singleItemFetched: (state, action) => {
      console.log(action.payload.coinStoresForEdit, "------------");
      state.actionsLoading = false;
      state.coinStoresForEdit = action.payload.coinStoresForEdit;
      state.error = null;
    },
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.map(entity => {
      //   if (entity._id === action.payload.item._id) {
      //     return action.payload.item;
      //   }
      //   return entity;
      // });
      state.entities = [];
    },
  },
});
